


document.addEventListener('DOMContentLoaded', function() {

  console.log('1. DOM Content Loaded');
  if (document.body.classList.contains('template-product')) {
    initPriceUpdates();
  }

});

function initPriceUpdates() {
  console.log('2. Initializing price updates');
  
  // Log all variant inputs
  const variantRadios = document.querySelectorAll('input[type="radio"][name^="Size"]');
  console.log('3. Found variant radios:', variantRadios.length, variantRadios);
  
  // Log the hidden variant ID input
  const variantIdInput = document.querySelector('input[name="id"]');
  console.log('4. Variant ID input:', variantIdInput, 'Current value:', variantIdInput?.value);
  
  // Log price container
  const priceContainer = findPriceContainer();
  console.log('5. Price container:', priceContainer);
  
  // Log all JSON data sources
  console.log('6. JSON scripts found:', document.querySelectorAll('script[type="application/json"]').length);
  
  const jsonScript = document.querySelector('script[data-selected-variant]');
  console.log('7. Selected variant script:', jsonScript);
  if (jsonScript) {
    try {
      const variantData = JSON.parse(jsonScript.textContent);
      console.log('8. Current variant data:', variantData);
    } catch (e) {
      console.log('8. Error parsing variant data:', e);
    }
  }
  
  // Setup event listeners with logging
  variantRadios.forEach((radio, index) => {
    console.log(`9. Setting up listener for radio ${index}:`, radio.value, 'checked:', radio.checked);
    radio.addEventListener('change', function(e) {
      console.log('=== VARIANT CHANGE DETECTED ===');
      console.log('10. Radio change event:', e.target.value, 'checked:', e.target.checked);
      console.log('11. Current variant ID before timeout:', getCurrentVariantId());
      
      setTimeout(() => {
        console.log('12. After timeout - Current variant ID:', getCurrentVariantId());
        handleVariantChange();
      }, 100);
    });
  });
  
  // Also watch variant ID input changes
  if (variantIdInput) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          console.log('13. Variant ID input changed:', mutation.target.value);
          setTimeout(handleVariantChange, 50);
        }
      });
    });
    
    observer.observe(variantIdInput, { 
      attributes: true,
      attributeFilter: ['value']
    });
    console.log('14. MutationObserver setup on variant ID input');
  }
  
  // Initial price setup
  console.log('15. Running initial price setup');
  handleVariantChange();
}

function handleVariantChange() {
  console.log('16. handleVariantChange called');
  
  const variantId = getCurrentVariantId();
  const priceContainer = findPriceContainer();
  
  console.log('17. Variant ID:', variantId, 'Price container:', priceContainer);
  
  if (!variantId) {
    console.log('18. No variant ID found');
    return;
  }
  
  if (!priceContainer) {
    console.log('19. No price container found');
    return;
  }
  
  const variantData = getVariantData(variantId);
  console.log('20. Variant data found:', variantData);
  
  if (variantData) {
    console.log('21. Updating price display');
    updatePriceDisplay(priceContainer, variantData);
  } else {
    console.log('21. No variant data found for ID:', variantId);
  }
}

function getCurrentVariantId() {
  const idInput = document.querySelector('input[name="id"]');
  const value = idInput ? idInput.value : null;
  console.log('getCurrentVariantId returning:', value);
  return value;
}

function getVariantData(variantId) {
  console.log('getVariantData called for:', variantId);
  
  // Check main JSON script
  const jsonScript = document.querySelector('script[data-selected-variant]');
  if (jsonScript) {
    try {
      const variant = JSON.parse(jsonScript.textContent);
      console.log('JSON script variant:', variant);
      if (variant && variant.id == variantId) {
        console.log('Matched variant from JSON script');
        return variant;
      }
    } catch (e) {
      console.log('Error parsing JSON script:', e);
    }
  }
  
  // Check schema
  const schemaData = getVariantDataFromSchema(variantId);
  console.log('Schema data:', schemaData);
  return schemaData;
}

function getVariantDataFromSchema(variantId) {
  console.log('getVariantDataFromSchema called for:', variantId);
  
  const schemaScript = document.querySelector('script[type="application/ld+json"]');
  if (!schemaScript) {
    console.log('No schema script found');
    return null;
  }
  
  try {
    const schema = JSON.parse(schemaScript.textContent);
    console.log('Full schema:', schema);
    
    if (schema && schema.hasVariant) {
      console.log('Schema has variants:', schema.hasVariant.length);
      
      for (const variant of schema.hasVariant) {
        const id = extractVariantId(variant['@id']);
        console.log('Checking variant:', variant.name, 'ID:', id, 'Target ID:', variantId);
        
        if (id == variantId && variant.offers) {
          console.log('Matched variant from schema');
          return {
            id: id,
            price: convertPriceToCents(variant.offers.price),
            compare_at_price: null,
            available: variant.offers.availability === 'http://schema.org/InStock'
          };
        }
      }
    }
  } catch (e) {
    console.log('Error parsing schema:', e);
  }
  
  return null;
}

function extractVariantId(url) {
  const match = url.match(/variant=(\d+)/);
  const result = match ? match[1] : null;
  console.log('extractVariantId:', url, '->', result);
  return result;
}

function convertPriceToCents(priceString) {
  const priceNum = parseFloat(priceString.replace('$', ''));
  const result = Math.round(priceNum * 100);
  console.log('convertPriceToCents:', priceString, '->', result);
  return result;
}

function findPriceContainer() {
  const container = document.querySelector('.price, [id^="price-"]');
  console.log('findPriceContainer found:', container);
  return container;
}

function updatePriceDisplay(priceContainer, variant) {
  console.log('updatePriceDisplay called with:', variant);
  
  const price = formatPrice(variant.price);
  const comparePrice = variant.compare_at_price ? formatPrice(variant.compare_at_price) : null;
  
  console.log('Price:', price, 'Compare Price:', comparePrice);
  
  // Update regular price
  const regularPriceEls = priceContainer.querySelectorAll('.price-item--regular');
  console.log('Regular price elements found:', regularPriceEls.length);
  
  regularPriceEls.forEach((el, index) => {
    console.log(`Regular price element ${index}:`, el.textContent);
    if (comparePrice && comparePrice !== price) {
      el.textContent = comparePrice;
      el.style.display = 'inline';
      console.log(`Updated regular price ${index} to:`, comparePrice);
    } else {
      el.style.display = 'none';
      console.log(`Hid regular price ${index}`);
    }
  });
  
  // Update sale price
  const salePriceEls = priceContainer.querySelectorAll('.price-item--sale, .price-item--last');
  console.log('Sale price elements found:', salePriceEls.length);
  
  salePriceEls.forEach((el, index) => {
    console.log(`Sale price element ${index} before:`, el.textContent);
    el.textContent = price;
    console.log(`Sale price element ${index} after:`, el.textContent);
  });
  
  // Update sale badge
  const saleBadge = priceContainer.querySelector('.price__badge-sale');
  console.log('Sale badge found:', saleBadge);
  
  if (saleBadge) {
    const shouldShow = (comparePrice && comparePrice !== price);
    saleBadge.style.display = shouldShow ? 'inline-block' : 'none';
    console.log('Sale badge display set to:', saleBadge.style.display);
  }
  
  // Update stock status
  updateStockStatus(variant.available);
}

function updateStockStatus(available) {
  const stockElement = document.querySelector('.product-info-extra .info-line:first-child span');
  console.log('Stock element found:', stockElement, 'Available:', available);
  
  if (stockElement) {
    if (available) {
      stockElement.textContent = 'In Stock';
      stockElement.style.color = '';
      console.log('Stock status set to: In Stock');
    } else {
      stockElement.textContent = 'Out of Stock';
      stockElement.style.color = '#b33a3a';
      console.log('Stock status set to: Out of Stock');
    }
  }
}

function formatPrice(price) {
  let result;
  
  if (typeof price === 'number') {
    result = '$' + (price / 100).toFixed(2);
  } else if (typeof price === 'string' && price.includes('$')) {
    result = price;
  } else {
    result = '$' + (parseInt(price) / 100).toFixed(2);
  }
  
  console.log('formatPrice:', price, '->', result);
  return result;
}


// document.addEventListener("DOMContentLoaded", function() {
//   function initVariantListeners(context = document) {
//     context.querySelectorAll(".variant-select").forEach(function(select) {
//       if (select.dataset.bound === "true") return;
//       select.dataset.bound = "true";

//       const productId = select.dataset.productId;
//       const productCard = select.closest(".product-card");

//       // Find the correct price span and hidden input inside the same product card
//       const priceSpan = productCard ? productCard.querySelector(".product-prices") : null;
//       const hiddenInput = productCard ? productCard.querySelector(`input[type='hidden'][name='id']`) : null;

//       function updatePrice() {
//         const selectedOption = select.options[select.selectedIndex];
//         if (!selectedOption) return;

//         // Update price text
//         if (priceSpan) priceSpan.textContent = selectedOption.dataset.price;

//         // Update hidden input value
//         if (hiddenInput) hiddenInput.value = selectedOption.value;
//       }

//       // Initial load
//       updatePrice();

//       // On variant change
//       select.addEventListener("change", updatePrice);
//     });
//   }

//   // Initialize on page load
//   initVariantListeners();

//   // Re-run when Shopify dynamically loads tabs or sections
//   document.addEventListener("shopify:section:load", (e) => {
//     initVariantListeners(e.target);
//   });

//   // Optional: If your tabs load dynamically via JS, also observe DOM changes
//   const observer = new MutationObserver((mutations) => {
//     mutations.forEach((m) => {
//       if (m.addedNodes.length) initVariantListeners();
//     });
//   });
//   observer.observe(document.body, { childList: true, subtree: true });
// });



-// skin-essentials.js
document.addEventListener("DOMContentLoaded", function() {
  initializeAllSkinEssentialsSections();
});

function initializeAllSkinEssentialsSections() {
  const skinWrappers = document.querySelectorAll(".cstm_skin_wrapper_main");
  
  if (skinWrappers.length === 0) return;
  
  console.log(`Found ${skinWrappers.length} skin essentials sections`);
  
  skinWrappers.forEach((wrapper, index) => {
    console.log(`Initializing skin essentials section ${index + 1}`);
    initializeSkinEssentials(wrapper);
  });
}

function initializeSkinEssentials(sectionElement) {
  if (!sectionElement) return;

  const tabs = sectionElement.querySelectorAll(".tab");
  const tabContents = sectionElement.querySelectorAll(".tab-content");
  const tabButton = sectionElement.querySelector(".view-all-btn"); // Scoped to section

  // Use dynamically generated tabLinks from Liquid
  const tabLinks = window.tabLinks || {};

  // Initialize tabs functionality
  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      const tabNumber = this.dataset.tab;

      // remove active class from all tabs in this section
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      // hide all tab contents in this section
      tabContents.forEach(content => content.classList.remove("active"));

      // show clicked tab content in this section
      const activeContent = sectionElement.querySelector(`#tab-content-${tabNumber}`);
      if (activeContent) {
        activeContent.classList.add("active");
        
        // Re-initialize variant functionality for the newly active tab AFTER it's visible
        setTimeout(() => {
          reinitializeTabContent(activeContent);
        }, 50);
      }

      // update "View All" button link dynamically in this section
      if (tabLinks[tabNumber] && tabButton) {
        tabButton.href = tabLinks[tabNumber];
      }
    });
  });

  // Initialize add to cart forms in this section
  initializeAddToCartForms(sectionElement);

  // Initialize everything with a delay to ensure DOM is ready
  setTimeout(() => {
    // Initialize all visible variant selects in this section
    initializeSkinEssentialsVariantSelects(sectionElement);
    initializeSkinEssentialsPrices(sectionElement);
    
    // Force initialization for active tab on load in this section
    const activeContent = sectionElement.querySelector('.tab-content.active');
    if (activeContent) {
      reinitializeTabContent(activeContent);
    }
  }, 300);
}

// NEW FUNCTION: Reinitialize a specific tab content
function reinitializeTabContent(tabContent) {
  // Reinitialize variant selects within this tab
  const variantSelects = tabContent.querySelectorAll('.variant-select');
  variantSelects.forEach(select => {
    // Remove and re-add event listener
    const newSelect = select.cloneNode(true);
    select.parentNode.replaceChild(newSelect, select);
    
    newSelect.addEventListener('change', function() {
      handleSkinEssentialsVariantChange(this);
    });
    
    // Initialize current price
    handleSkinEssentialsVariantChange(newSelect);
  });

  // Reinitialize add to cart forms within this tab
  const forms = tabContent.querySelectorAll('.add-to-cart-form');
  forms.forEach(form => {
    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);
    
    newForm.addEventListener('submit', function(e) {
      e.preventDefault();
      handleAddToCart(this);
    });
  });
}

function initializeAddToCartForms(sectionElement) {
  const forms = sectionElement.querySelectorAll('.add-to-cart-form');
  
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      handleAddToCart(this);
    });
  });
}

function handleAddToCart(form) {
  const formData = new FormData(form);
  const button = form.querySelector('.add-to-cart');
  const linkElement = button.querySelector('a');
  const originalLinkText = linkElement.textContent;
  
  // Update only the <a> tag text
  linkElement.textContent = 'Adding...';
  button.disabled = true;
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    linkElement.textContent = 'Added!';
    setTimeout(() => {
      // Revert back to original text
      linkElement.textContent = originalLinkText;
      button.disabled = false;
    }, 2000);
    
    // Update cart count if you have a cart drawer
    if (typeof window.updateCartCount === 'function') {
      window.updateCartCount();
    }
  })
  .catch(error => {
    console.error('Error:', error);
    linkElement.textContent = 'Error';
    setTimeout(() => {
      // Revert back to original text
      linkElement.textContent = originalLinkText;
      button.disabled = false;
    }, 2000);
  });
}

// Initialize prices on page load for a specific section
function initializeSkinEssentialsPrices(sectionElement) {
  if (!sectionElement) return;
  
  const variantSelects = sectionElement.querySelectorAll('.variant-select');
    
  variantSelects.forEach((select) => {
    handleSkinEssentialsVariantChange(select);
  });
}

// Separate function for variant selects in a specific section
function initializeSkinEssentialsVariantSelects(sectionElement) {
  if (!sectionElement) return;
  
  const variantSelects = sectionElement.querySelectorAll('.variant-select');
    
  if (variantSelects.length === 0) {
    return;
  }

  variantSelects.forEach((select, index) => {
    select.addEventListener('change', function() {
      handleSkinEssentialsVariantChange(this);
    });
    
    // Initialize the current value
    handleSkinEssentialsVariantChange(select);
  });
}

// Separate function to handle variant changes
function handleSkinEssentialsVariantChange(selectElement) {
  if (!selectElement) {
    console.error('Skin Essentials - No select element provided');
    return;
  }
  
  const selectedVariantId = selectElement.value;
  const productId = selectElement.dataset.productId;
    
  if (!productId || !selectedVariantId) {
    console.error('Skin Essentials - Missing productId or selectedVariantId');
    return;
  }
  
  // Find the parent section of the select element
  const sectionElement = selectElement.closest('.cstm_skin_wrapper_main');
  if (!sectionElement) {
    console.error('Skin Essentials - No parent section found');
    return;
  }
  
  // Find form by data-product-id attribute - search within the active tab content of this section
  const activeTabContent = sectionElement.querySelector('.tab-content.active');
  if (!activeTabContent) {
    console.error('Skin Essentials - No active tab content found in section');
    return;
  }
  
  const form = activeTabContent.querySelector(`.cstm-add-to-cart-form[data-product-id="${productId}"]`);
  
  if (!form) {
    console.error('Skin Essentials - Form not found for product:', productId);
    return;
  }
    
  // Update variant input
  let variantInput = form.querySelector(`.variant-id-${productId}`);
  
  if (!variantInput) {
    variantInput = form.querySelector('input[name="id"]');
  }
  
  // Only update if variantInput exists
  if (variantInput) {
    variantInput.value = selectedVariantId;
  } else {
    console.error('Skin Essentials - Variant input not found');
  }
  
  // Find price element - search within the form
  let priceElement = form.querySelector('.product-prices');
  
  if (!priceElement) {
    console.error('Skin Essentials - Price element not found in form');
    return;
  }
  
  // Find the selected option to get the price
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  
  // Update price if data-price attribute exists
  if (selectedOption && selectedOption.dataset.price) {
    priceElement.textContent = selectedOption.dataset.price;
    
    // Force a DOM update
    priceElement.style.display = 'none';
    priceElement.offsetHeight; // Trigger reflow
    priceElement.style.display = '';
  } 
  // Fallback to API call if no data-price
  else {
    const originalPrice = priceElement.textContent;
    priceElement.textContent = 'Loading...';
    
    fetch(`/variants/${selectedVariantId}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Variant not found');
        }
        return response.json();
      })
      .then(variant => {
        // Use Shopify's money format or fallback
        let formattedPrice;
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          formattedPrice = Shopify.formatMoney(variant.price, window.moneyFormat || "{{ shop.money_format | escape }}");
        } else {
          // Fallback formatting
          formattedPrice = '$' + (variant.price / 100).toFixed(2);
        }
        priceElement.textContent = formattedPrice;
      })
      .catch(error => {
        console.error('Skin Essentials - Error fetching variant:', error);
        priceElement.textContent = originalPrice;
      });
  }
}

// Additional initialization as backup with longer timeout
setTimeout(() => {
  initializeAllSkinEssentialsSections();
}, 1500);

